import { forwardRef, type ReactNode } from 'react';
import { Box, type Theme, type SxProps } from '@mui/material';
import { StyledLabel, type StyledLabelProps } from './styles';

type LabelVariant = StyledLabelProps['ownerState']['variant'];
type LabelColor = StyledLabelProps['ownerState']['color'];

interface LabelProps {
	sx?: SxProps<Theme>;
	startIcon?: ReactNode;
	endIcon?: ReactNode;
	children?: ReactNode;
	variant?: LabelVariant;
	color?: LabelColor;
}

const Label = forwardRef<HTMLSpanElement, LabelProps>(
	({ children, color = 'default', variant = 'soft', startIcon, endIcon, sx, ...other }, ref) => {
		const iconStyle = {
			width: 16,
			height: 16,
			'& svg, img': { width: 1, height: 1, objectFit: 'cover' },
		};

		return (
			<StyledLabel
				ref={ref}
				component="span"
				ownerState={{ color, variant }}
				sx={{
					...(startIcon && { pl: 0.75 }),
					...(endIcon && { pr: 0.75 }),
					...sx,
				}}
				{...other}
			>
				{startIcon && <Box sx={{ mr: 0.75, ...iconStyle }}>{startIcon}</Box>}

				{children}

				{endIcon && <Box sx={{ ml: 0.75, ...iconStyle }}>{endIcon}</Box>}
			</StyledLabel>
		);
	},
);

export default Label;
